import { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
    Calendar,
    ArrowRight,
    Search,
    TrendingUp,
    Clock,
    Sparkles,
    ChevronLeft,
    ChevronRight
} from "lucide-react";
import SEO from "../components/SEO";
import { supabase } from "../supabaseClient";

const MOCK_POSTS = [
    {
        id: "c8f1e092-7b54-4a91-9e20-3d712f8a4e10",
        slug: "top-global-accounting-challenges-solutions-2026",
        title: "Top Global Accounting Challenges & Solutions in 2026: The Strategic Playbook",
        excerpt: "Discover the biggest challenges reshaping global accounting in 2026—from real-time e-invoicing and multi-currency volatility to AI automation—and actionable solutions to keep your business compliant and competitive.",
        author: "Mohit",
        date: "Oct 11, 2026",
        readTime: "9 min read",
        category: "Global Finance",
        image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=1200",
        featured: false
    },
    {
        id: "m0b1l3-4cc0-unt1-ng20-26wh4ts4pp01",
        slug: "mobile-accounting-whatsapp-invoicing-guide",
        title: "The Complete Guide to Mobile Accounting & WhatsApp Invoicing in 2026: How to Collect Payments 3x Faster",
        excerpt: "Learn how mobile accounting and instant WhatsApp invoicing help small businesses create GST bills on phone, automate payment collection reminders, and recover dues in hours.",
        author: "Mohit",
        date: "Sep 01, 2026",
        readTime: "8 min read",
        category: "Mobile Billing",
        image: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&q=80&w=1200",
        featured: true
    },
    {
        id: "a1b2c3d4-e5f6-7a8b-9c0d-1e2f3a4b5c6d",
        slug: "top-5-ai-accounting-tools-2026",
        title: "Top 5 AI Accounting Tools in 2026: The Definitive Comparison",
        excerpt: "Compare the best AI-powered accounting software in 2026. See how blinqbooks, QuickBooks, Xero, Zoho Books, and FreshBooks stack up in automation, features, and value.",
        author: "Mohit",
        date: "Sep 01, 2026",
        readTime: "9 min read",
        category: "Software Review",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800",
        featured: false
    },
    {
        id: "b2c3d4e5-f6a7-8b9c-0d1e-2f3a4b5c6d7e",
        slug: "blinqbooks-vs-quickbooks-comparison",
        title: "blinqbooks vs QuickBooks Online (2026): Which Is Right for Your Business?",
        excerpt: "An in-depth head-to-head comparison between blinqbooks and QuickBooks Online. Compare AI automation, pricing, ERP integration, and ease of use.",
        author: "Mohit",
        date: "Sep 01, 2026",
        readTime: "8 min read",
        category: "Software Review",
        image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800",
        featured: false
    },
    {
        id: "9f4e21a8-c743-4e89-91a5-298da5f82bb1",
        slug: "accounting-with-ai-complete-guide",
        title: "Accounting with AI: The Complete Guide to Smarter Bookkeeping & Financial Automation",
        excerpt: "Discover how AI in accounting automates bookkeeping, eliminates manual errors, cuts operating costs, and delivers real-time cash flow forecasting.",
        author: "Mohit",
        date: "Mar 01, 2026",
        readTime: "7 min read",
        category: "Artificial Intelligence",
        image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=800",
        featured: false
    },
    {
        id: "376b4fdc-a533-4d03-bd61-c4fa8db7c4ee",
        slug: "future-of-ai-in-accounting",
        title: "The Future of AI in Accounting: How autonomous systems are changing the game",
        excerpt: "Discover how AI-driven bookkeeping is eliminating manual entry and providing real-time financial insights for SMEs.",
        author: "Mohit",
        date: "Dec 24, 2025",
        readTime: "8 min read",
        category: "Artificial Intelligence",
        image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&q=80&w=800",
        featured: false
    },
    {
        id: "43660834-0e7f-43b7-a01c-8d868f8067e2",
        slug: "optimize-ecommerce-pos-tips",
        title: "10 Tips to Optimize Your E-commerce POS for the Holiday Season",
        excerpt: "Learn how to sync your inventory across physical and digital stores to maximize sales during peak demand.",
        author: "Sarah Chen",
        date: "Dec 15, 2025",
        readTime: "5 min read",
        category: "E-Commerce",
        image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&q=80&w=800",
        featured: false
    },
    {
        id: "578a9bfe-92ba-46b7-9cff-87e9402faf5b",
        slug: "building-brand-on-budget-ai-content",
        title: "Building a Brand on a Budget: The Power of AI Content Generation",
        excerpt: "Why high-quality social media content doesn't need to cost a fortune in 2026. Insights from our marketing engine.",
        author: "Priya Sharma",
        date: "Dec 08, 2025",
        readTime: "6 min read",
        category: "Marketing",
        image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&q=80&w=800",
        featured: false
    },
    {
        id: "89368ccd-290a-4d8e-8171-b8fb847051c5",
        slug: "scaling-startup-employees",
        title: "Scaling Your Startup: From 1 to 50 Employees Seamlessly",
        excerpt: "Automate your HR and payroll so you can focus on building what matters. A guide for founders.",
        author: "Michael Ross",
        date: "Nov 30, 2025",
        readTime: "10 min read",
        category: "Growth",
        image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800",
        featured: false
    }
];

export default function Blog() {
    const [posts, setPosts] = useState(MOCK_POSTS);
    const [activeCategory, setActiveCategory] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");

    const [newsletterEmail, setNewsletterEmail] = useState("");
    const [newsletterStatus, setNewsletterStatus] = useState("idle"); // idle, loading, success, error
    const [newsletterMsg, setNewsletterMsg] = useState("");

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        if (!newsletterEmail) return;

        setNewsletterStatus("loading");
        setNewsletterMsg("");

        try {
            const { error } = await supabase
                .from("newsletter_subscribers")
                .insert([{ email: newsletterEmail }]);

            if (error) throw error;

            setNewsletterStatus("success");
            setNewsletterMsg("Thank you! You've been subscribed.");
            setNewsletterEmail("");
        } catch (err) {
            console.error("Newsletter error:", err);
            if (err.code === "23505") {
                setNewsletterStatus("error");
                setNewsletterMsg("This email is already subscribed!");
            } else {
                setNewsletterStatus("error");
                setNewsletterMsg("Something went wrong. Please try again.");
            }
        }
    };

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const { data, error } = await supabase
                    .from("blog_posts")
                    .select("*")
                    .order("created_at", { ascending: false });

                if (error) throw error;

                if (data && data.length > 0) {
                    const formatted = data.map(post => ({
                        id: post.id,
                        slug: post.slug || post.id,
                        title: post.title,
                        excerpt: post.excerpt,
                        content: post.content,
                        author: post.author,
                        date: post.date,
                        readTime: post.read_time,
                        category: post.category,
                        image: post.image_url,
                        featured: post.featured
                    }));
                    setPosts(formatted);
                }
            } catch (error) {
                console.error("Error fetching blog posts from Supabase:", error);
            }
        };

        fetchPosts();
    }, []);

    // Dynamically derive categories
    const categories = useMemo(() => {
        return ["All", ...Array.from(new Set(posts.map(p => p.category))).filter(Boolean).sort()];
    }, [posts]);

    const categorySliderRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);

    const checkScrollButtons = () => {
        if (categorySliderRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = categorySliderRef.current;
            setCanScrollLeft(scrollLeft > 8);
            setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 8);
        }
    };

    useEffect(() => {
        checkScrollButtons();
        window.addEventListener("resize", checkScrollButtons);
        return () => window.removeEventListener("resize", checkScrollButtons);
    }, [categories]);

    const scrollSlider = (direction) => {
        if (categorySliderRef.current) {
            const scrollAmount = direction === "left" ? -220 : 220;
            categorySliderRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
    };

    // Filter logic
    const filteredPosts = posts.filter(post => {
        // Handle category matching: "AI" -> "Artificial Intelligence", otherwise exact (case insensitive)
        const matchesCat = activeCategory === "All" ||
            (activeCategory === "AI" && (post.category.toLowerCase().includes("ai") || post.category.toLowerCase().includes("artificial intelligence"))) ||
            (post.category.toLowerCase() === activeCategory.toLowerCase());

        const matchesSearch = searchQuery.trim() === "" ||
            post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            post.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (post.content && post.content.toLowerCase().includes(searchQuery.toLowerCase())) ||
            post.author.toLowerCase().includes(searchQuery.toLowerCase()) ||
            post.category.toLowerCase().includes(searchQuery.toLowerCase());

        return matchesCat && matchesSearch;
    });

    const isFiltered = activeCategory !== "All" || searchQuery.trim() !== "";
    const featuredPost = !isFiltered ? filteredPosts.find(p => p.featured) : null;
    const regularPosts = !isFiltered ? filteredPosts.filter(p => !p.featured) : filteredPosts;

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
            <SEO
                title="Blog - Insights for Modern Entrepreneurs"
                description="Explore the latest in AI-driven business, accounting tips, e-commerce growth strategies, and enterprise automation on the blinqbooks blog."
            />

            {/* Hero / Category Section */}
            <section className="pt-20 pb-12 px-4">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-bold uppercase mb-6"
                        >
                            <TrendingUp className="w-4 h-4" />
                            Latest Insights
                        </motion.div>
                        <h1 className="text-4xl md:text-6xl font-bold text-primary dark:text-white mb-6">The blinqbooks <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-emerald-500">Blog</span></h1>
                        <p className="text-secondary dark:text-gray-400 max-w-2xl mx-auto text-lg font-medium">
                            Weekly expert deep-dives into AI, automation, and the future of business operations.
                        </p>
                    </div>

                    {/* Search & Categories Filters */}
                    <div className="flex flex-col lg:flex-row gap-5 items-center justify-between pb-8 border-b border-slate-200/50 dark:border-slate-800/50">
                        {/* Slidable Category Filter Bar */}
                        <div className="relative flex items-center w-full lg:max-w-[72%] overflow-hidden py-1">
                            {/* Left Scroll Button */}
                            {canScrollLeft && (
                                <button
                                    onClick={() => scrollSlider("left")}
                                    className="hidden sm:flex absolute left-0 z-10 w-8 h-8 rounded-full bg-surface dark:bg-slate-900 shadow-md border border-subtle items-center justify-center text-primary dark:text-white hover:bg-surface-hover backdrop-blur-sm transition-all cursor-pointer"
                                    aria-label="Scroll left"
                                >
                                    <ChevronLeft className="w-4 h-4" />
                                </button>
                            )}

                            {/* Left gradient fade */}
                            {canScrollLeft && (
                                <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-gray-50 dark:from-gray-900 to-transparent z-[5]" />
                            )}

                            {/* Slider */}
                            <div
                                ref={categorySliderRef}
                                onScroll={checkScrollButtons}
                                className="flex items-center gap-2.5 overflow-x-auto no-scrollbar scroll-smooth w-full px-1 sm:px-4"
                            >
                                {categories.map((cat) => {
                                    const isActive = activeCategory === cat;
                                    return (
                                        <button
                                            key={cat}
                                            onClick={() => setActiveCategory(cat)}
                                            className={`shrink-0 px-5 py-2 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap select-none ${isActive
                                                ? "bg-accent text-white shadow-md shadow-accent/20 scale-[1.02]"
                                                : "bg-slate-500/[0.04] dark:bg-white/[0.03] text-secondary dark:text-gray-300 hover:bg-slate-500/[0.08] dark:hover:bg-white/[0.06] border border-slate-200/60 dark:border-slate-800/60"
                                                }`}
                                        >
                                            {cat}
                                        </button>
                                    );
                                })}
                            </div>

                            {/* Right gradient fade */}
                            {canScrollRight && (
                                <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-gray-50 dark:from-gray-900 to-transparent z-[5]" />
                            )}

                            {/* Right Scroll Button */}
                            {canScrollRight && (
                                <button
                                    onClick={() => scrollSlider("right")}
                                    className="hidden sm:flex absolute right-0 z-10 w-8 h-8 rounded-full bg-surface dark:bg-slate-900 shadow-md border border-subtle items-center justify-center text-primary dark:text-white hover:bg-surface-hover backdrop-blur-sm transition-all cursor-pointer"
                                    aria-label="Scroll right"
                                >
                                    <ChevronRight className="w-4 h-4" />
                                </button>
                            )}
                        </div>

                        {/* Search Bar */}
                        <div className="relative w-full lg:w-72 shrink-0">
                            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search articles..."
                                className="w-full pl-11 pr-4 py-2.5 rounded-xl bg-slate-500/5 dark:bg-white/5 border border-slate-200 dark:border-slate-800 text-sm focus:ring-2 focus:ring-accent outline-none text-primary dark:text-white"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Featured Post */}
            {!isFiltered && featuredPost && (
                <section className="pb-20 px-4 animate-fade-in">
                    <div className="max-w-7xl mx-auto">
                        <Link
                            to={`/blog/${featuredPost.slug || featuredPost.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block focus:outline-none"
                        >
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                className="relative group rounded-[2.5rem] overflow-hidden bg-slate-500/[0.02] dark:bg-white/[0.01] hover:bg-slate-500/[0.04] dark:hover:bg-white/[0.02] transition-all duration-300 cursor-pointer"
                            >
                                <div className="grid grid-cols-1 lg:grid-cols-2">
                                    <div className="h-[300px] lg:h-full relative overflow-hidden">
                                        <img
                                            src={featuredPost.image}
                                            alt={featuredPost.title}
                                            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent"></div>
                                        <div className="absolute top-6 left-6">
                                            <span className="px-4 py-2 rounded-lg bg-accent text-white text-xs font-bold flex items-center gap-2">
                                                <Sparkles className="w-3 h-3" /> Featured Post
                                            </span>
                                        </div>
                                    </div>
                                    <div className="p-8 lg:p-16 flex flex-col justify-center">
                                        <div className="flex items-center gap-4 text-xs text-gray-500 mb-6">
                                            <span className="px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 font-bold uppercase tracking-wider">{featuredPost.category}</span>
                                            <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {featuredPost.date}</span>
                                        </div>
                                        <h2 className="text-3xl lg:text-4xl font-bold text-primary dark:text-white mb-6 group-hover:text-accent transition-colors leading-tight">
                                            {featuredPost.title}
                                        </h2>
                                        <p className="text-secondary dark:text-gray-400 text-lg mb-8 leading-relaxed">
                                            {featuredPost.excerpt}
                                        </p>

                                        <div className="flex items-center justify-between mt-auto pt-6">
                                            <div className="flex items-center gap-3">
                                                <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center font-bold text-primary dark:text-white">
                                                    {featuredPost.author[0]}
                                                </div>
                                                <div>
                                                    <div className="text-sm font-bold dark:text-white">{featuredPost.author}</div>
                                                    <div className="text-[10px] text-gray-500 uppercase tracking-widest">{featuredPost.readTime}</div>
                                                </div>
                                            </div>
                                            <div className="p-4 rounded-full bg-primary dark:bg-accent text-white hover:-translate-y-1 transition-all">
                                                <ArrowRight className="w-6 h-6" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </Link>
                    </div>
                </section>
            )}

            {/* Posts Grid */}
            <section className="pb-24 px-4">
                <div className="max-w-7xl mx-auto">
                    {filteredPosts.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {regularPosts.map((post, i) => (
                                <Link
                                    key={post.id}
                                    to={`/blog/${post.slug || post.id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block group h-full focus:outline-none"
                                >
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: i * 0.1 }}
                                        className="flex flex-col h-full bg-slate-500/[0.02] dark:bg-white/[0.01] rounded-3xl overflow-hidden hover:bg-slate-500/[0.04] dark:hover:bg-white/[0.02] transition-all cursor-pointer border border-transparent hover:border-slate-200 dark:hover:border-slate-800"
                                    >
                                        <div className="h-56 relative overflow-hidden">
                                            <img
                                                src={post.image}
                                                alt={post.title}
                                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                            />
                                            <div className="absolute top-4 left-4">
                                                <span className="px-3 py-1 rounded-full bg-white/90 backdrop-blur-md text-[#0f4c81] text-[10px] font-bold uppercase tracking-widest">{post.category}</span>
                                            </div>
                                        </div>
                                        <div className="p-8 flex flex-col flex-grow">
                                            <div className="flex items-center gap-3 text-[10px] text-gray-500 mb-4 font-bold uppercase tracking-widest">
                                                <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {post.date}</span>
                                                <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {post.readTime}</span>
                                            </div>
                                            <h3 className="text-xl font-bold text-primary dark:text-white mb-4 group-hover:text-accent transition-colors leading-snug">
                                                {post.title}
                                            </h3>
                                            <p className="text-sm text-secondary dark:text-gray-400 mb-6 leading-relaxed line-clamp-2">
                                                {post.excerpt}
                                            </p>

                                            <div className="mt-auto pt-6 border-t border-slate-100 dark:border-slate-800/50 flex items-center justify-between">
                                                <div className="flex items-center gap-2">
                                                    <div className="w-8 h-8 rounded-full bg-accent/10 flex items-center justify-center font-bold text-accent text-xs">
                                                        {post.author[0]}
                                                    </div>
                                                    <span className="text-xs font-bold text-primary dark:text-white">{post.author}</span>
                                                </div>
                                                <span className="text-accent group-hover:translate-x-1 transition-transform">
                                                    <ArrowRight className="w-4 h-4" />
                                                </span>
                                            </div>
                                        </div>
                                    </motion.div>
                                </Link>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-20 animate-fade-in">
                            <div className="text-gray-400 dark:text-gray-600 text-6xl mb-6">🔍</div>
                            <h3 className="text-2xl font-bold text-primary dark:text-white mb-2">No matching articles found</h3>
                            <p className="text-secondary dark:text-gray-400 max-w-md mx-auto">
                                Try adjusting your search query or choosing a different category to find what you're looking for.
                            </p>
                            <button
                                onClick={() => { setActiveCategory("All"); setSearchQuery(""); }}
                                className="mt-8 px-6 py-2.5 rounded-full bg-accent text-white font-bold hover:bg-accent-hover transition-all cursor-pointer shadow-md"
                            >
                                Reset Filters
                            </button>
                        </div>
                    )}

                    {/* Newsletter Signup */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        className="mt-32 p-12 lg:p-20 rounded-[3rem] bg-gradient-to-br from-blue-600 to-emerald-600 relative overflow-hidden text-center text-white"
                    >
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-[80px] -mr-32 -mt-32"></div>
                        <div className="relative z-10">
                            <h2 className="text-3xl lg:text-5xl font-black mb-6">Stay ahead of the curve.</h2>
                            <p className="text-blue-100 max-w-xl mx-auto mb-10 text-lg">Join 20,000+ entrepreneurs receiving our weekly digest on AI and business growth.</p>
                            <form className="max-w-md mx-auto flex flex-col gap-3" onSubmit={handleNewsletterSubmit}>
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <input
                                        type="email"
                                        value={newsletterEmail}
                                        onChange={(e) => setNewsletterEmail(e.target.value)}
                                        placeholder="Enter your email"
                                        required
                                        disabled={newsletterStatus === "loading"}
                                        className="flex-grow px-6 py-4 rounded-xl bg-white/20 text-white placeholder-blue-100 focus:outline-none focus:ring-2 focus:ring-white/50 disabled:opacity-50"
                                    />
                                    <button
                                        type="submit"
                                        disabled={newsletterStatus === "loading" || !newsletterEmail}
                                        className="btn-primary bg-white hover:bg-white/90 text-[#0F4C81] font-bold disabled:opacity-50"
                                    >
                                        {newsletterStatus === "loading" ? "Submitting..." : "Subscribe Now"}
                                    </button>
                                </div>
                                {newsletterMsg && (
                                    <p className={`text-sm font-semibold mt-2 ${newsletterStatus === "success" ? "text-emerald-300" : "text-red-300"
                                        }`}>
                                        {newsletterMsg}
                                    </p>
                                )}
                            </form>
                        </div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
}
